module.exports = require('./helpers/bundle-url').getBundleURL('glq1z') + "logo-dark.eefe0b7f.svg";